import { render, staticRenderFns } from "./gzzoc-disease-pdf.vue?vue&type=template&id=6be7c876&scoped=true&lang=pug&"
import script from "./gzzoc-disease-pdf.vue?vue&type=script&lang=js&"
export * from "./gzzoc-disease-pdf.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-disease-pdf.vue?vue&type=style&index=0&id=6be7c876&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be7c876",
  null
  
)

export default component.exports